export default __webpack_public_path__ + "static/media/Bus.d064225f.svg";